import React from 'react';
import AreaDetailPage from './AreaDetailPage';
import { diningAreas } from '../data/mapData';

function DiningArea({ area }) {
  const config = diningAreas[area] || diningAreas.restaurant;
  return <AreaDetailPage config={config} sectionHeader="On Site Dining" />;
}

export default DiningArea;
